import React from 'react';
import _values from 'lodash/values';
import { css } from '@emotion/react';

import type { WModuleView } from '@zola/svc-web-api-ts-client';
import { trackRecommendation } from 'util/trackingHelper';
import { StyledImgWrapper, StyledLinkV2 } from './PromoTile.styles';

export type PromoTileProps = {
  module: WModuleView;
  position: number;
};
export const PromoTile = (props: PromoTileProps) => {
  const { module, position } = props;

  const {
    link_label: linkLabel,
    link_path: linkPath,
    images_by_dimension: imagesByDimension,
  } = module;
  const imgSrc = _values(imagesByDimension)[0];

  function handleClick() {
    trackRecommendation('Clicked', {
      recommendation_key: 'PLP Ad Tile Clicked',
      recommendation_name: `Ad Tile #${position}`,
      recommendation_copy: linkLabel,
      location: 'PLP',
      section: '',
    });
  }

  return linkPath ? (
    <StyledLinkV2
      css={css`
        background: url(${imgSrc});
        background-size: cover;
      `}
      onClick={handleClick}
      href={linkPath}
      target="_blank"
      rel="noopener noreferrer"
    />
  ) : (
    <StyledImgWrapper
      css={css`
        background: url(${imgSrc});
        background-size: cover;
      `}
    />
  );
};
